import React from "react";
import { useParams } from "react-router-dom";
import { PhoneCall } from "lucide-react";
import { PageHeader } from "../../components/common";
import { MobileChangeLogReport } from "../../components/MobileChangeLogReport";

/**
 * Phase 204 — Reports › Mobile Number Change Log (Municipal Admin; Super Admin via Mobile Numbers → Change Log).
 * Every owner mobile number UPDATE and VERIFICATION ("Number is correct") made by Tax Collectors and Supervisors on
 * the property page, with the receipt collected in the same visit. Visible only after the Super Admin grants the
 * Role Access feature "MIS Reports → Mobile Number Change Log" to this municipality.
 */
export default function MobileChangeLog() {
  const { code } = useParams();
  return (
    <div data-testid="admin-mobile-change-log-page">
      <PageHeader title="Mobile Number Change Log"
        subtitle="Who changed or confirmed an owner's mobile number, when, from which number to which — with the receipt collected in the same visit. Filter by date, Zone, Ward, staff member, role or event type and export to Excel.">
        <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground"><PhoneCall className="h-3.5 w-3.5" aria-hidden="true" /> Field Collectors & Supervisors</span>
      </PageHeader>
      <MobileChangeLogReport code={code} testId="admin-mcl" propertyPath={(r) => `/${code}/admin/properties?focus=${r.property_id}`} />
    </div>
  );
}
